import React from "react";
import SweetAlert from "react-bootstrap-sweetalert";

const DeleteProviderAlert = ({ providerName, onConfirm, onCancel }) => {
  return (
    <SweetAlert
      showCancel
      style={{ display: "block", marginTop: "-100px" }}
      title="Confirm Deletion"
      onConfirm={onConfirm}
      onCancel={onCancel}
      confirmBtnBsStyle="danger"
    >
      {`Are you sure you want to delete provider "${providerName}"?`}
    </SweetAlert>
  );
}

export default DeleteProviderAlert;
